export function setupHelpers() {
	/* #### Global Helpers #### */
	window.helpers = {};
	/* ## Core JS ## */
	// note: lodash _.clonedeep is better but is also a 20mb import by itself.  yikes.
	// window.helpers.deepClone = require('lodash.clonedeep');
	// eslint-disable-next-line
	window.helpers.deepClone = (src) => { let target = {}; for (let prop in src) { if (src.hasOwnProperty(prop)) { target[prop] = src[prop]; } } return target; }
	window.helpers.isFunction = (checkThis) => { if (typeof checkThis !== 'undefined') { return checkThis && {}.toString.call(checkThis) === '[object Function]'; } }
	/* ## Requests ## */
	window.params = new URLSearchParams(window.location.search);
	/* ## Debugging ## */
	// eslint-disable-next-line
	window.debug = (debug_output) => { if (window.portal.debugging) { console.log(debug_output); } }
}